import ArticleRow from './ArticleRow';

export default ArticleRow;
